export interface AccessCardPresentation {
  title: string;
  badge: string;
  action: 'none' | 'upgrade' | 'manage';
}

/** Pure presentation state for the free launch and its paid-mode rollback. */
export function accessCardPresentation(
  freeAccessEnabled: boolean,
  isPaidSubscriber: boolean,
): AccessCardPresentation {
  if (freeAccessEnabled) {
    return {
      title: 'VizDay is free',
      badge: 'Included',
      action: isPaidSubscriber ? 'manage' : 'none',
    };
  }
  return isPaidSubscriber
    ? { title: 'VizDay Plus', badge: 'Active', action: 'manage' }
    : { title: 'Upgrade to Plus', badge: '$4.99/mo', action: 'upgrade' };
}
